import { useSelector } from "react-redux";

import * as executionBriefWorkOrderStore from "../../../../../pages/execution-brief/store/execution-brief-work-orders/execution-brief-work-orders.store";

import { IForm } from "../../../form-modal/form-modal.types";
import { TextInput } from "../../../form-modal/inputs/text-input/text-input.component";
import { SpinnerLoader } from "../../../../loaders";
import { SelectField } from "../../../../../features/forms/fields/select-field/select-field.component";
import usePermissions from "../../../../../hooks/usePermissions";

export const DuplicateExecutionBriefForm = (props: IForm) => {
  const isLoading = useSelector(executionBriefWorkOrderStore.isLoading);
  const workOrders = useSelector(executionBriefWorkOrderStore.getWorkOrders);
  const userPermissions = usePermissions();

  const options = workOrders.map((wo) => ({
    label: `${wo.name} - ${wo.status}`,
    value: wo.id,
  }));

  return (
    <>
      <TextInput form={props.form} label="Multi Channel Brief Name" name="name" required />
      <SpinnerLoader showIf={isLoading} inline size={25} />
      <SelectField
        showIf={!isLoading && !!options.length}
        form={props.form}
        label="Work Orders to duplicate"
        multiple
        name="workOrders"
        options={options}
        userPermissions={userPermissions}
        withToggleAll
      />
    </>
  );
};
